<template>
  <v-list-item link v-on:click="visitAssociatedPage">
    <v-list-item-icon>
      <v-icon>{{ item.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "DrawerItem",
  props: {
    item: Object
  },
  methods: {
    visitAssociatedPage() {
      if (this.item.link && this.$route.name !== this.item.link) {
        this.$router.push({ name: this.item.link });
      }
    }
  }
};
</script>
